/**
 *
 * InitiativeEditForm
 *
 */
import React, { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { useQuery } from '@apollo/client';
import { GET_INITIATIVE_DETAILS } from 'app/graphql/queries';

import { numberToGlobalId } from 'app/helpers/helperFunctions';

import { Loading } from '../Loading';

import { Helmet } from 'react-helmet-async';

import GeneralDetails from './GeneralDetailsForm';
import RelatedDocsForm from './RelatedDocsForm';
import RolesForm from './RolesForm';
import ShiftsForm from './ShiftsForm';
import InitiativeEditFormStyles from './styles';

import { Col, Collapse, Row, message } from 'antd';

import { EditInitiative } from 'app/redux/actions/initiatives';

export const InitiativeEditForm = memo(props => {
  const [generalDetails, setGeneralDetails] = useState({
    english_name: '',
    arabic_name: '',
    english_description: '',
    arabic_description: '',
    starting_date: '',
    ending_date: '',
    starting_time: '',
    ending_time: '',
    location: '',
    tag: '',
    image: '',
    contract_en: '',
    contract_ar: '',
    registration_closed: false,
  });

  const dispatch = useDispatch();

  const [errorMessage, setErrorMessage] = useState(null);

  const { initiativeID } = useParams();

  const initiativeGID = numberToGlobalId('InitiativeNode', initiativeID);

  const { loading: initiativeLoading, data: initiativeData } = useQuery(
    GET_INITIATIVE_DETAILS,
    {
      variables: { id: initiativeGID },
    },
  );

  const onGeneralDetailsChange = event => {
    setGeneralDetails({
      ...generalDetails,
      [event.target.name]:
        event.target.name === 'image' ||
        event.target.name === 'contract_en' ||
        event.target.name === 'contract_ar'
          ? event.target.files[0]
          : event.target.value,
    });
  };

  const onGeneralDetailsFinish = async () => {
    const response = await dispatch(
      EditInitiative(generalDetails, initiativeID),
    );

    if (typeof response === 'string' && response.includes('Error'))
      setErrorMessage(response);
    else {
      setErrorMessage(null);

      message.config({
        top: 0, // push to the top
      });

      message.success({
        content: 'Updated Successfully',
        duration: 2, // Displays the success message for 2 seconds
      });

      // Wait for the success message to disappear before reloading
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Matches the duration of the success message
    }
  };

  if (initiativeLoading) return <Loading />;

  const initiative = initiativeData?.initiative;

  const collapseItems = [
    {
      key: '1',
      label: 'General Details',
      children: (
        <GeneralDetails
          onChange={onGeneralDetailsChange}
          data={generalDetails}
          setData={setGeneralDetails}
          initiative={initiative}
          onFinish={onGeneralDetailsFinish}
          errorMessage={errorMessage}
        />
      ),
    },
    {
      key: '2',
      label: 'Related Documents',
      children: (
        <RelatedDocsForm
          docsList={initiative?.relatedDocs?.edges}
          initiativeID={initiativeID}
        />
      ),
    },
    {
      key: '3',
      label: 'Roles',
      children: (
        <RolesForm
          rolesList={initiative?.roles?.edges}
          initiativeID={initiativeID}
        />
      ),
    },
    {
      key: '4',
      label: 'Shifts',
      children: (
        <ShiftsForm
          shiftsList={initiative?.shifts?.edges}
          initiativeID={initiativeID}
        />
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>General Details Form</title>
        <meta name="description" content="General Details Form" />
      </Helmet>

      <InitiativeEditFormStyles>
        <Row gutter={[8, 8]}>
          <Col xs={24}>
            <Collapse defaultActiveKey={['1']} items={collapseItems} />
          </Col>
        </Row>
      </InitiativeEditFormStyles>
    </>
  );
});
